import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TooltipComponent } from '../../../../components/tooltip/tooltip.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MAX_LENGTH_REJECTION_CANCELATION_REASON, MIN_LENGTH_DESCRIPTION, getControlsWithErrors } from 'util/form.utility';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass } from '@angular/common';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'services/toast.service';
import { BaseFormModalComponent } from 'components/modal/base-form-modal.component';
import { BackofficeReadingRoomSubmissionCard } from 'types/service.interface';
import { formatDate, formatTime } from 'util/date.utility';

@Component({
  selector: 'app-reject-submission-modal',
  standalone: true,
  imports: [TooltipComponent, TranslateModule, FormsModule, ReactiveFormsModule, NgClass],
  templateUrl: './reject-submission-modal.component.html',
  styleUrl: './reject-submission-modal.component.scss'
})
export class RejectSubmissionModalComponent extends BaseFormModalComponent implements OnChanges, AfterViewInit {
  @Input() application?: BackofficeReadingRoomSubmissionCard;
  @Input() applicationId!: string;
  @Input() isOpen!: boolean;
  @ViewChild('content') content!: TemplateRef<any>;
  @Output() isOpenChange = new EventEmitter<boolean>();
  maxDescriptionLength = MAX_LENGTH_REJECTION_CANCELATION_REASON;
  public readonly formatDate = formatDate;
  public readonly formatTime = formatTime;
  shouldRenderTooltip = false;
  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngAfterViewInit(): void {
    if (this.isOpen && !this.modalService.hasOpenModals()) {
      this.initForm();
      this.open(this.content);
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.initForm();
      this.shouldRenderTooltip = false;
      this.open(this.content);
      setTimeout(() => {
        this.shouldRenderTooltip = true;
      }, 10);
    }
  }

  override open(content: TemplateRef<any>): void {
    this.modalService
      .open(content, {
        backdrop: true,
        keyboard: true,
        centered: true
      })
      .result.catch(() => {
        this.hide();
      });
  }

  get text(): AbstractControl<any, any> | null {
    return this.form.get('text');
  }
  get id(): AbstractControl<any, any> | null {
    return this.form.get('id');
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      id: [this.applicationId ?? null],
      text: [
        '',
        [Validators.required, Validators.maxLength(MAX_LENGTH_REJECTION_CANCELATION_REASON), Validators.minLength(MIN_LENGTH_DESCRIPTION)]
      ]
    });
  }

  handleSave() {
    if (this.form.valid) {
      this.submitAttempted = false;
      this.onConfirm();
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.rejectSubmission');
    }
  }

  hide() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
    this.close();
  }

  onConfirm() {
    this.confirm.emit(this.text?.value);
    this.isOpen = false;
    this.isOpenChange.emit(false);
    this.modalService.dismissAll();
  }
}
